import { Chip } from '@otp/ui';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const IsActiveColumn = ({
  isDisabled,
  isDeleted,
}: {
  isDisabled?: boolean;
  isDeleted?: boolean;
}) => {
  const { t } = useTranslation();

  if (isDeleted) {
    return <Chip label={t('common.archived')} color="warning" />;
  }

  if (isDisabled) {
    return <Chip label={t('common.inactive')} color="default" />;
  }

  return <Chip label={t('common.active')} color="primary" />;
};
